import {
  GET_SF_FILTERS,
  GET_SF_FILTERS_SUCCESS,
  GET_SF_FILTERS_ERROR,
  GET_SOURCE_TYPES,
  GET_SOURCE_TYPES_SUCCESS,
  GET_SOURCE_TYPES_ERROR,
  GET_SF_SMART_VIEWS,
  GET_SF_SMART_VIEWS_SUCCESS,
  GET_SF_SMART_VIEWS_ERROR,
  GET_CAMPAIGN_SOURCE_TYPES,
  GET_CAMPAIGN_SOURCE_TYPES_SUCCESS,
  GET_CAMPAIGN_SOURCE_TYPES_ERROR,
  GET_SOURCE_TYPES_BY_ACCOUNT,
  GET_SOURCE_TYPES_BY_ACCOUNT_SUCCESS,
  GET_SOURCE_TYPES_BY_ACCOUNT_ERROR,
  GET_MARKETING_GROUPS,
  GET_MARKETING_GROUPS_SUCCESS,
  GET_MARKETING_GROUPS_ERROR
} from "./actionTypes"

export const getSfFilters = () => {
  return {
    type: GET_SF_FILTERS,
  }
}

export const getSfFiltersSuccess = sf_filters => {
  return {
    type: GET_SF_FILTERS_SUCCESS,
    payload: sf_filters,
  }
}

export const getSfFiltersError = error => {
  return {
    type: GET_SF_FILTERS_ERROR,
    payload: error,
  }
}

export const getSourceTypes = () => {
  return {
    type: GET_SOURCE_TYPES,
  }
}

export const getSourceTypesSuccess = source_types => {
  return {
    type: GET_SOURCE_TYPES_SUCCESS,
    payload: source_types
  }
}

export const getSourceTypesError = error => {
  return {
    type: GET_SOURCE_TYPES_ERROR,
    payload: error
  }
}

export const getSfSmartViews = () => {
  return {
    type: GET_SF_SMART_VIEWS
  }
}

export const getSfSmartViewsSuccess = sf_smart_views => {
  return {
    type: GET_SF_SMART_VIEWS_SUCCESS,
    payload: sf_smart_views
  }
}

export const getSfSmartViewsError = error => {
  return {
    type: GET_SF_SMART_VIEWS_ERROR,
    payload: error
  }
}

export const getCampaignSourceTypes = (campaign_id) => {
  return {
    type: GET_CAMPAIGN_SOURCE_TYPES,
    payload: { campaign_id }
  }
}

export const getCampaignSourceTypesSuccess = campaign_source_types => {
  return {
    type: GET_CAMPAIGN_SOURCE_TYPES_SUCCESS,
    payload: campaign_source_types
  }
}

export const getCampaignSourceTypesError = error => {
  return {
    type: GET_CAMPAIGN_SOURCE_TYPES_ERROR,
    payload: error
  }
}

export const getSourceTypesByAccount = (payload) => {
  return {
    type: GET_SOURCE_TYPES_BY_ACCOUNT,
    payload: payload
  }
}

export const getSourceTypesByAccountSuccess = source_types_by_account => {
  return {
    type: GET_SOURCE_TYPES_BY_ACCOUNT_SUCCESS,
    payload: source_types_by_account
  }
}

export const getSourceTypesByAccountError = error => {
  return {
    type: GET_SOURCE_TYPES_BY_ACCOUNT_ERROR,
    payload: error
  }
}

export const getMarketingGroups = () => {
  return {
    type: GET_MARKETING_GROUPS
  }
}

export const getMarketingGroupsSuccess = marketing_groups => {
  return {
    type: GET_MARKETING_GROUPS_SUCCESS,
    payload: marketing_groups
  }
}

export const getMarketingGroupsError = error => {
  return {
    type: GET_MARKETING_GROUPS_ERROR,
    payload: error
  }
}
